import React from "react";

import Card from "./Card";
import Link from "../../../components/Link";
import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Section from "../../../components/Section";
import ContentGrid from "../../../components/ContentGrid";

import style from "./style.module.css";

export default function ArticleCarousel(props) {
    const {
        enlarge_title,
        show_hover_popup = 0,
        wrap_articles,
        view_all_button_label = null,
        view_all_button_link = null,
        title = "",
        article = [],
        autoplay = false,
        delay = 5000
    } = props;

    return (
        <>
        {
            (article || []).length > 0 && (
                <Section className={style.articleCarousel}>
                    <div className={style.articleCarouselRow}>
                        <div className={`${style.sectionHeader}`}>
                            {
                                title !== "" && (
                                    <div className={`${style.sectionTitle}`}>
                                        <Title
                                            transform="uppercase"
                                            tag={enlarge_title === 1 ? "h1" : "h4"}
                                            className="fontTeko"
                                        >
                                            {title}
                                        </Title>
                                    </div>
                                )
                            }
                            {
                                view_all_button_label !== null && view_all_button_link !== null && (
                                    <Link to={view_all_button_link}>{view_all_button_label}</Link>
                                )
                            }
                        </div>
                        <div className={`${style.sectionBody}`}>
                            {
                                (title !== "" || view_all_button_label !== null) && (
                                    <Spacer size="24" />
                                )
                            }
                            {
                                article.length > 0 && (
                                    <ContentGrid
                                        items={article}
                                        wrap={wrap_articles}
                                        autoplay={autoplay}
                                        Component={Card}
                                        show_hover_popup={show_hover_popup}
                                        col={wrap_articles === 1 ? "col4" : "col1"}
                                        delay={delay}
                                    />
                                )
                            }
                        </div>
                    </div>
                </Section>
            )
        }
        </>
    )
}